export function Concept() {
  return (
    <section id="concept" className="brand-story">
      <div className="container">
        <div className="concept-wrapper">
          {/* 装飾ライン（左） */}
          <div className="concept-decoration-left">
            <div className="vertical-line"></div>
          </div>

          {/* メインコンテンツ */}
          <div className="concept-main">
            <div className="concept-header">
              <span className="concept-subtitle">CONCEPT</span>
              <img
                src="/assets/img/kamando_logo_alpha.png"
                alt="Kamando"
                className="concept-logo"
              />
            </div>

            <div className="concept-lead">
              <p>
                香ばしいかおりに包まれる、ちょっと贅沢な日常を。
                <br />
                毎日を心地よく彩るパン工房です。
              </p>
            </div>

            <div className="concept-body">
              <div className="concept-text-block">
                <p>
                  カリッと香ばしいハード系パン、ふんわり食パン、具だくさんのデリパン、そしてご褒美になるスイーツ系まで
                  他のお店にはない、バラエティ豊かなパンをそろえています。
                </p>
              </div>
              <div className="concept-text-block">
                <p>
                  パンの生地はすべてこだわり。
                  <br />
                  種類に合わせて粉や作り方を変えているから、それぞれのパンが一番美味しい状態で仕上がります。
                </p>
              </div>
              <div className="concept-text-block">
                <p>焼きたてだからこそ味わえる、香りと食感をお楽しみください。</p>
              </div>
            </div>
          </div>

          {/* 装飾ライン（右） */}
          <div className="concept-decoration-right">
            <div className="vertical-line"></div>
          </div>
        </div>
      </div>
    </section>
  )
}
